<div *ngIf="orderDetails">
    <!-- Header -->
    <div class="order-summary-header">
        <div class="order-summary-header-inner">
            <div class="header-left">
                <div class="page-name">Upload Bill Of Lading</div>
            </div>
            <div class="header-right">
                <div class="header-right-order">Order Number</div>
                <div id="order-number" class="header-right-number">#{{ orderDetails.orderNumber }}</div>
            </div>
        </div>
    </div>

    <!-- Main Content -->
    <div class="order-summary-main order-summary-main-top-header">
        <div class="order-summary-main-inner">
            <div class="order-summary-main-center">
                <!-- Order Details Section -->
                <div class="summary-header-block">
                    <div class="summary-header-block__header">Order Details</div>
                </div>
                <div class="info-block__base">
                    <div class="info-block__line--blue"></div>
                    <div class="info-block__main">
                        <div class="info-block__row">
                            <span class="info-block__row__header">Order Number</span>
                            <span class="info-block__row__value">#{{ orderDetails.orderNumber }}</span>
                        </div>
                        <div class="info-block__row">
                            <span class="info-block__row__header">Broker Name</span>
                            <span class="info-block__row__value">{{ orderDetails.brokerName }}</span>
                        </div>
                        <div class="info-block__row" *ngIf="orderDetails.brokerDispatchContact">
                            <span class="info-block__row__header">Dispatch Contact</span>
                            <span class="info-block__row__value">{{ orderDetails.brokerDispatchContact }}</span>
                        </div>
                        <div class="info-block__row" *ngIf="orderDetails.brokerDispatchPhone">
                            <span class="info-block__row__header">Broker Dispatch Phone</span>
                            <span class="info-block__row__value">{{ orderDetails.brokerDispatchPhone }}</span>
                        </div>
                    </div>
                </div>

                <!-- Route Section -->
                <div class="summary-header-block mt-4">
                    <div class="summary-header-block__header">Route</div>
                </div>
                <div class="info-block__base">
                    <div class="info-block__line--blue"></div>
                    <div class="info-block__main">
                        <div class="info-block__row">
                            <span class="info-block__row__header">Origin</span>
                            <span class="info-block__row__value">
                                <div>{{ orderDetails.originAddressLine1 }}</div>
                                <div>{{ orderDetails.origin }}</div>
                            </span>
                        </div>
                        <div class="info-block__row">
                            <span class="info-block__row__header">Destination</span>
                            <span class="info-block__row__value">
                                <div>{{ orderDetails.destinationAddressLine1 }}</div>
                                <div>{{ orderDetails.destination }}</div>
                            </span>
                        </div>
                    </div>
                </div>

                <!-- BOL Files Section -->
                <div class="summary-header-block mt-4">
                    <div class="summary-header-block__header">BOL Files</div>
                    <div class="summary-header-block__subtitle">(after you are finished uploading files, simply close this window)</div>
                </div>
                <div class="bol-files-section">
                    <!-- Error Message -->
                    <div *ngIf="errorMessage" class="alert alert-danger mt-3" role="alert">
                        {{ errorMessage }}
                    </div>

                    <!-- Uploaded Files List -->
                    <div *ngIf="uploadedFiles.length > 0" class="uploaded-files-list mt-3">
                        <div *ngFor="let uploadedFile of uploadedFiles" class="uploaded-file-item">
                            <div class="file-info">
                                <i class="fa-solid fa-file"></i>
                                <span class="file-name">{{ uploadedFile.fileName }}</span>
                                <span class="file-size">({{ formatFileSize(uploadedFile.file.size) }})</span>
                            </div>
                            <button
                                type="button"
                                class="btn btn-sm btn-danger"
                                (click)="deleteFile(uploadedFile)"
                                title="Delete file">
                                <i class="fa-solid fa-trash"></i>
                            </button>
                        </div>
                    </div>

                    <!-- Add File Button -->
                    <div class="mt-3">
                        <input
                            type="file"
                            #fileInput
                            (change)="onFileSelected($event)"
                            [accept]="'.jpg,.jpeg,.png,.gif,.bmp,.pdf'"
                            [multiple]="true"
                            style="display: none;">
                        <button
                            type="button"
                            class="btn btn-primary"
                            [disabled]="!canAddMoreFiles || isUploading"
                            (click)="fileInput.click()">
                            <i class="fa-sharp fa-solid fa-circle-plus me-2"></i>
                            <span *ngIf="!isUploading">Add File</span>
                            <span *ngIf="isUploading">
                                <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Uploading...
                            </span>
                        </button>
                        <div class="form-text mt-2">
                            Allowed formats: JPG, JPEG, PNG, GIF, BMP, PDF. Max file size: 20MB. Max {{ MAX_FILES }} files total.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

